function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/perfect-month");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "7.03125e-05 0 45 0 45 47.9999652 7.03125e-05 47.9999652"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "7.03125e-05 0 45 0 45 44.5217043 7.03125e-05 44.5217043"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "7.03125e-05 0 45 0 45 44.5217043 7.03125e-05 44.5217043"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-480.000000, -777.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/perfect-month",
  transform: "translate(480.000000, 777.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5000703,47.9999652 L22.5000703,47.9999652 C10.0733906,47.9999652 7.03125e-05,38.0333565 7.03125e-05,25.7390957 L7.03125e-05,4.17387826 C7.03125e-05,1.86883478 1.88901563,-3.47826087e-05 4.21882031,-3.47826087e-05 L40.7813203,-3.47826087e-05 C43.111125,-3.47826087e-05 45.0000703,1.86883478 45.0000703,4.17387826 L45.0000703,25.7390957 C45.0000703,38.0333565 34.9263984,47.9999652 22.5000703,47.9999652",
  id: "Fill-1",
  fill: "#AD8D07",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5000703,44.5217043 L22.5000703,44.5217043 C10.0733906,44.5217043 7.03125e-05,34.5550957 7.03125e-05,22.2608348 L7.03125e-05,4.17387826 C7.03125e-05,1.86883478 1.88901563,-3.47826087e-05 4.21882031,-3.47826087e-05 L40.7813203,-3.47826087e-05 C43.111125,-3.47826087e-05 45.0000703,1.86883478 45.0000703,4.17387826 L45.0000703,22.2608348 C45.0000703,34.5550957 34.9263984,44.5217043 22.5000703,44.5217043",
  id: "Fill-4",
  fill: "#FFDC4A",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7813203,-3.47826087e-05 L4.21882031,-3.47826087e-05 C1.88901563,-3.47826087e-05 7.03125e-05,1.86883478 7.03125e-05,4.17387826 L7.03125e-05,22.2608348 C7.03125e-05,34.5550957 10.0733906,44.5217043 22.5000703,44.5217043 L22.5000703,44.5217043 C34.9263984,44.5217043 45.0000703,34.5550957 45.0000703,22.2608348 L45.0000703,4.17387826 C45.0000703,1.86883478 43.111125,-3.47826087e-05 40.7813203,-3.47826087e-05 M40.7813203,4.17387826 L40.7813203,22.2608348 C40.7813203,32.2340522 32.5804219,40.3477913 22.5000703,40.3477913 C12.4197188,40.3477913 4.21882031,32.2340522 4.21882031,22.2608348 L4.21882031,4.17387826 L40.7813203,4.17387826",
  id: "Fill-7",
  fill: "#D3AB05",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.9049414,31.7419826 L16.0950586,31.7419826 C14.1533789,31.7419826 12.5794336,30.1847652 12.5794336,28.2637217 L12.5794336,15.5899826 C12.5794336,13.6689391 14.1533789,12.1117217 16.0950586,12.1117217 L28.9049414,12.1117217 C30.8466211,12.1117217 32.4205664,13.6689391 32.4205664,15.5899826 L32.4205664,28.2637217 C32.4205664,30.1847652 30.8466211,31.7419826 28.9049414,31.7419826",
  id: "Fill-10",
  fill: "#D3AB05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.9049414,29.9017043 L16.0950586,29.9017043 C14.1533789,29.9017043 12.5794336,28.344487 12.5794336,26.4234435 L12.5794336,13.7497043 C12.5794336,11.8286609 14.1533789,10.2714435 16.0950586,10.2714435 L28.9049414,10.2714435 C30.8466211,10.2714435 32.4205664,11.8286609 32.4205664,13.7497043 L32.4205664,26.4234435 C32.4205664,28.344487 30.8466211,29.9017043 28.9049414,29.9017043",
  id: "Fill-12",
  fill: "#FFF1B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5794336,16.7125217 L12.5794336,13.3386087 C12.5794336,11.6446957 13.9674023,10.2714783 15.6795117,10.2714783 L29.3204883,10.2714783 C31.0325977,10.2714783 32.4205664,11.6446957 32.4205664,13.3386087 L32.4205664,16.7125217 L12.5794336,16.7125217 Z",
  id: "Fill-14",
  fill: "#AD8D07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2827266,13.264487 L18.2827266,13.264487 C17.7690937,13.264487 17.3524922,12.8526609 17.3524922,12.3441391 L17.3524922,9.65787826 C17.3524922,9.14970435 17.7690937,8.73787826 18.2827266,8.73787826 C18.7963594,8.73787826 19.2129609,9.14970435 19.2129609,9.65787826 L19.2129609,12.3441391 C19.2129609,12.8526609 18.7963594,13.264487 18.2827266,13.264487",
  id: "Fill-16",
  fill: "#B6C4CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.7172734,13.264487 L26.7172734,13.264487 C26.2036406,13.264487 25.7870391,12.8526609 25.7870391,12.3441391 L25.7870391,9.65787826 C25.7870391,9.14970435 26.2036406,8.73787826 26.7172734,8.73787826 C27.2309063,8.73787826 27.6475078,9.14970435 27.6475078,9.65787826 L27.6475078,12.3441391 C27.6475078,12.8526609 27.2309063,13.264487 26.7172734,13.264487",
  id: "Fill-18",
  fill: "#B6C4CE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.1424063,20.306087 L22.4913516,25.2563478 L23.8575234,20.306087 C23.9640469,19.9307826 24.0484219,19.6612174 24.111,19.498087 C24.1735781,19.3346087 24.2825625,19.1881739 24.4383047,19.0587826 C24.5936953,18.9290435 24.8007656,18.8643478 25.0588125,18.8643478 C25.2672891,18.8643478 25.4392031,18.9029565 25.5738516,18.9798261 C25.7085,19.0566957 25.8178359,19.1655652 25.9011562,19.3064348 C25.9844766,19.4473043 26.0530313,19.6142609 26.1061172,19.8076522 C26.1592031,20.0010435 26.2066641,20.1801739 26.2481484,20.3453913 L27.6371719,25.904 C27.7204922,26.2267826 27.7623281,26.4726957 27.7623281,26.6417391 C27.7623281,26.8556522 27.6867422,27.0358261 27.5348672,27.1826087 C27.3829922,27.3286957 27.1952578,27.402087 26.9713125,27.402087 C26.6640469,27.402087 26.4573281,27.3043478 26.3508047,27.1092174 C26.2446328,26.914087 26.1518203,26.6306087 26.0720156,26.2587826 L24.9790078,21.4382609 L23.7552188,25.9492174 C23.6641641,26.2946087 23.5826016,26.5572174 23.5101797,26.7373913 C23.4384609,26.917913 23.3206875,27.0733913 23.1575625,27.2048696 C22.9944375,27.3363478 22.77225,27.402087 22.4913516,27.402087 C22.2069375,27.402087 21.9858047,27.3335652 21.8283047,27.1965217 C21.6708047,27.0594783 21.5618203,26.9102609 21.501,26.7488696 C21.4405312,26.5874783 21.3589687,26.3206957 21.2563125,25.9492174 L20.0212734,21.4382609 L18.9282656,26.2587826 C18.8751797,26.5102609 18.8249063,26.7074783 18.7770937,26.850087 C18.7299844,26.9926957 18.6484219,27.1206957 18.5327578,27.2330435 C18.4170937,27.3457391 18.2490469,27.402087 18.0289688,27.402087 C17.8088906,27.402087 17.6218594,27.3297391 17.467875,27.1853913 C17.3145938,27.0406957 17.2376016,26.8594783 17.2376016,26.6417391 C17.2376016,26.4876522 17.2794375,26.2417391 17.3631094,25.904 L18.7517813,20.3453913 C18.8467031,19.970087 18.9254531,19.6949565 18.9880312,19.5203478 C19.0506094,19.3457391 19.1567813,19.1926957 19.3065469,19.0615652 C19.4566641,18.930087 19.6683047,18.8643478 19.9411172,18.8643478 C20.1995156,18.8643478 20.4062344,18.9283478 20.5619766,19.056 C20.7177187,19.1833043 20.8256484,19.3269565 20.8861172,19.4866087 C20.9469375,19.6462609 21.0323672,19.9193043 21.1424063,20.306087",
  id: "Fill-20",
  fill: "#0A0A0A"
})))));

var SvgPerfectMonth = function SvgPerfectMonth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerfectMonth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/perfect-month.2192a868.svg";
export { ForwardRef as ReactComponent };